import { MaterialModule } from './material.module';
import { DisableIfUnauthorizedDirective } from './../directives/disable-if-unauthorized.directive';
import { HideIfUnauthorizedDirective } from './../directives/hide-if-unauthorized.directive';
import { CommonModule } from '@angular/common';
import { NgModule, ApplicationModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '@core/footer/footer.component';
import { HeaderComponent } from '@core/header/header.component';
import { UserManualsDownloadComponent } from '@components/documentation/user-manuals-download/user-manuals-download.component';
import { HoverNotificationComponent } from '@core/hover-notification/hover-notification.component';
import { InlineEditComponent } from '@core/inline-edit/inline-edit.component';
import { InvalidRowsComponent } from '@core/invalid-rows/invalid-rows.component';
import { MultiNotificationComponent } from '@core/multi-notification/multi-notification.component';
import { TemplateComponent } from '@core/template/template.component';
import { LaunchMainDialogDirective } from '@directives/launch-main-dialog.directive';
import { RunSimulationDirective } from '@directives/run-simulation.directive';
import { ImporterStatusDirective } from '@directives/importer-status.directive';
import { AuthorizeDirective } from '@directives/authorize.directive';
import { EmpyreanLoaderModule } from './empyrean-loader/empyrean-loader.module';
import { ApplicationSwitcherModule } from './application-switcher/application-switcher.module';
// import { ZoomLevelSpreadsheetComponent } from './zoom-level-spreadsheet/zoom-level-spreadsheet.component';

const declarationsAndExports = [
  // Components
  FooterComponent,
  HeaderComponent,
  HoverNotificationComponent,
  InlineEditComponent,
  InvalidRowsComponent,
  MultiNotificationComponent,
  TemplateComponent,
  // ZoomLevelSpreadsheetComponent,

  // Directives
  LaunchMainDialogDirective,
  RunSimulationDirective,
  ImporterStatusDirective,
  HideIfUnauthorizedDirective,
  DisableIfUnauthorizedDirective,
  AuthorizeDirective,
];

// const services = [MultiNotificationsService, WindowRef];

const modules = [CommonModule, BrowserModule, FormsModule, RouterModule, MaterialModule, EmpyreanLoaderModule, ApplicationSwitcherModule,UserManualsDownloadComponent];

@NgModule({
  imports: modules,
  declarations: declarationsAndExports,
  exports: declarationsAndExports,
})
export class CoreModule {}
